export default __webpack_public_path__ + "static/media/logo.9a9f7427.svg";